var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_vm._v(" "+_vm._s(_vm.formattedValue)+" "),(_vm.done)?_c('Icon',{staticClass:"ml-1",attrs:{"name":"checkmark","color":"#E0F7EC","size":"small"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }